import { generatePath } from "@routes/utils";
import type { IExtractParams } from "@routes/types";

const pathBase = `/users/`;
const mePath = `${pathBase}me/`;
const usersPathById = `${pathBase}:userId/`;
const activatePath = `${usersPathById}activate/`;
const deactivatePath = `${usersPathById}deactivate/`;
const userAvatarPath = `${usersPathById}avatar/`;
const userNotificationSettingPath = `${usersPathById}notifications/settings/`;
const userPasswordChangePath = `${pathBase}password/change/`;
const userPasswordResetPath = `${pathBase}password/reset/`;
const userPasswordResetConfirmPath = `${pathBase}password/reset/confirm/`;
const assignStaffToMember = `${pathBase}:userId/assign/`;

export type IUsersPathParams = IExtractParams<typeof usersPathById>;
export type IAssignStaffToMemberPathParams = IExtractParams<
  typeof assignStaffToMember
>;

export const users = {
  getAll: () => generatePath(pathBase, null),
  post: () => generatePath(pathBase, null),
  get: (param: IUsersPathParams) => generatePath(usersPathById, param),
  put: (param: IUsersPathParams) => generatePath(usersPathById, param),
  patch: (param: IUsersPathParams) => generatePath(usersPathById, param),
  delete: (param: IUsersPathParams) => generatePath(usersPathById, param),
  assignStaffToMember: {
    post: (param: IAssignStaffToMemberPathParams) =>
      generatePath(assignStaffToMember, param),
  },
  activate: {
    post: (param: IUsersPathParams) => generatePath(activatePath, param),
  },
  deactivate: {
    post: (param: IUsersPathParams) => generatePath(deactivatePath, param),
  },
  me: {
    get: () => generatePath(mePath, null),
  },
  avatar: {
    post: (param: IUsersPathParams) => generatePath(userAvatarPath, param),
    delete: (param: IUsersPathParams) => generatePath(userAvatarPath, param),
  },
  notification: {
    get: (param: IUsersPathParams) =>
      generatePath(userNotificationSettingPath, param),
    put: (param: IUsersPathParams) =>
      generatePath(userNotificationSettingPath, param),
    patch: (param: IUsersPathParams) =>
      generatePath(userNotificationSettingPath, param),
  },
  password: {
    change: {
      post: () => generatePath(userPasswordChangePath, null),
    },
    reset: {
      post: () => generatePath(userPasswordResetPath, null),
      confirm: {
        post: () => generatePath(userPasswordResetConfirmPath, null),
      },
    },
  },
};
